// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"86a467a0","191":"629f977e","441":"31aabc6a","453":"23cb2979","622":"efa0abbf"}[chunkId] + ".chunk.js";
};